import EmployeeWorkInComponents from "../components/EmployeeWorkIn";
import useEmployeeWorkIn from "../hooks/useEmployeeWorkIn";

function EmployeeWorkIn() {
  const employeeWorkInProps = useEmployeeWorkIn();
  return <EmployeeWorkInComponents {...employeeWorkInProps} />;
}

export default EmployeeWorkIn;
